import './stepProgressBar.scss';
import { useNavigate } from 'react-router';

export interface StepProgressBarProps {
    steps: { index: number; label: string; path?: string }[];
    currentStep: number;
    setCurrentStep?: (step: number) => void;
}

export const StepProgressBar = ({ steps, currentStep, setCurrentStep }: StepProgressBarProps) => {
    const navigate = useNavigate();

    const items = steps.map((step) => {
        return (
            <div
                className={
                    'step-item ' + (currentStep === step.index ? 'active' : currentStep > step.index ? 'completed' : '')
                }
                key={step.index}
                onClick={() => {
                    if (currentStep > step.index) {
                        if (step.path) {
                            navigate(step.path);
                        } else if (setCurrentStep) {
                            setCurrentStep(step.index);
                        }
                    }
                }}>
                <div className="step-counter">{currentStep <= step.index ? step.index + 1 : ''}</div>
                <div className="step-name">{step.label}</div>
            </div>
        );
    });

    return <div className="stepProgressBar">{items}</div>;
};
export default StepProgressBar;
